import { render } from "./StuffTypeForm.vue?vue&type=template&id=baa26ad4"
import script from "./StuffTypeForm.vue?vue&type=script&lang=js"
export * from "./StuffTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__